<script lang="ts">
  import Link from "svelte-link";
  import { href } from "../../../../utils/Constant/Constant";
  import data from "../../../../Data/Users/Users.json"
  import UserFollowList from "./UserFollowList.svelte";
</script>
<div class="user-designation">
    <div class="title">
      <Link target="_self" href={href}>
        <h4>{'Emay Walter'}</h4>
        <h6>{'designer'}</h6>
      </Link>
    </div>
    <div class="social-media">
      <ul class="user-list-social">
        {#each data.userprofiledata as userItem }
            <li>
                <Link href={userItem.link}><i class={userItem.icon} /></Link>
            </li>
        {/each}
      </ul>
    </div>
    <div class="follow">
      <UserFollowList />
    </div>
</div>